'use client';
import Script from 'next/script';
import React from 'react';
import { PersistGate } from 'redux-persist/integration/react';

import { DashboardModalProvider } from '@Components/conditional-wrappers/modal-provider2';
import { AppAuthProvider } from '@Components/core/app-auth-provider';
import AppStartupProvider from '@Components/core/app-startup-wrapper';
import { ToastWrapper } from '@Components/design-system/notification/styled';
import NextTopLoader from '@Components/design-system/top-loader';
import ErrorBoundaryComponent from '@Components/error';
import { persistor } from '@Redux/store';

import { PHProvider } from '../components/provider';
import StoreProvider from './store-provider';

import '@Styles/globals.css';
import 'react-toastify/dist/ReactToastify.css';
import dynamic from 'next/dynamic';

const PostHogPageView = dynamic(() => import('../components/post-hog-page-view'), {
  ssr: false,
});

export default function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <html>
      <head>
        <Script
          id='gtag-base'
          strategy='beforeInteractive'
          dangerouslySetInnerHTML={{
            __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', '${process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID}');
          `,
          }}
        />
        <Script
          id='fb-pixel'
          strategy='beforeInteractive'
          dangerouslySetInnerHTML={{
            __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '7725819737489420');
            `,
          }}
        />
        <link rel='preconnect' href='https://fonts.googleapis.com' />
        <link rel='preconnect' href='https://fonts.gstatic.com' crossOrigin={'true'} />
        <link
          href='https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap'
          rel='stylesheet'
        />
        <link
          href='https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap'
          rel='stylesheet'></link>
        <link
          href='https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@100;200;300;400;500;600;700;800;900'
          rel='stylesheet'></link>
        <link
          rel='stylesheet'
          href='https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20,300,0,0'
        />
        <link
          rel='stylesheet'
          href='https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20,300,0..1,0'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1, maximum-scale=1'></meta>
      </head>

      <body>
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID}`}
            height='0'
            width='0'
            style={{ display: 'none', visibility: 'hidden' }}
          />
        </noscript>
        <noscript>
          <img
            alt=''
            height='1'
            width='1'
            style={{ display: 'none' }}
            src='https://www.facebook.com/tr?id=7725819737489420&ev=PageView&noscript=1'
          />
        </noscript>
        <PersistGate persistor={persistor}>
          <StoreProvider>
            <ErrorBoundaryComponent>
              <PHProvider>
                <AppStartupProvider>
                  <AppAuthProvider>
                    <DashboardModalProvider>
                      <PostHogPageView />
                      <NextTopLoader />
                      {children}
                    </DashboardModalProvider>
                  </AppAuthProvider>
                  <ToastWrapper />
                </AppStartupProvider>
              </PHProvider>
            </ErrorBoundaryComponent>
          </StoreProvider>
        </PersistGate>
        <script type='text/javascript' src='https://checkout.razorpay.com/v1/checkout.js' async></script>
      </body>
    </html>
  );
}
